// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "d320e741" + "." + "3cc28facff204374" + ".js";
};